/** In-page anchors of the docs page. Client-safe. */

/** "games.players" → "games-players" (the anchor error messages and other pages link to). */
export function endpointAnchor(id: string): string {
  return id.replace(/\./g, "-");
}

function slug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** "Charts & catalog" → "group-charts-catalog" (prefixed so a group can't share an endpoint's anchor). */
export function groupAnchor(group: string): string {
  return `group-${slug(group)}`;
}

/** "Game summary" → "object-game-summary". */
export function objectAnchor(title: string): string {
  return `object-${slug(title)}`;
}

/** Anchor of one row of the errors table. */
export function errorAnchor(code: string): string {
  return `error-${code.replace(/_/g, "-")}`;
}
